export enum TransferPeriodAction {
    Replace = 'replace',
    Transfer = 'transfer',
    Substitute = 'substitute' 
  }